export default __webpack_public_path__ + "static/media/MyRightel.0cd94b5e.jpg";